module.exports = __webpack_public_path__ + "static/media/yongbo.af367efc.png";